import React, { Component } from 'react';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import * as moment from 'moment';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { Buscar } from '../../services/perfis';
import { criptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

class MeusDados extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dados: {},
            idade: ''
        };
    }

    componentDidMount() {
        const token = localStorage.getItem('token');

        Buscar(token).then(response => {
            criptoLocalStorage('Nome', response.Nome);
            criptoLocalStorage('Email', response.Email);
            criptoLocalStorage('Codigo', response.CPF);
            criptoLocalStorage('Link', response.Link);
            criptoLocalStorage('codigo_vendedor', response.codigo);

            const data1 = moment(response.Nascimento).add(3, 'hours').format('YYYY');
            const data2 = new Date().getFullYear();

            this.setState({
                dados: response,
                idade: (data2 - data1)
            });
        }).catch(function (erro) {
            this.setState({
                loading: 'loading',
                submit: false
            });
        });
    }

    render() {
        const header = (
            <img alt="Card" src={fundo_amarelo} />
        );

        return (
            <div className="p-col-12 p-md-12 p-lg-12">
                <Card header={header} title="Meus dados">
                    <div className="content-section implementation">
                        <Fieldset legend="Dados Pessoais">
                            <p><strong>Nome:</strong> {this.state.dados['Nome']}</p>
                            <p><strong>Telefone:</strong> {this.state.dados['Telefone']} <strong>Idade:</strong> {this.state.idade} anos</p>
                            <p><strong>Email:</strong> {this.state.dados['Email']} </p>
                        </Fieldset>
                        <br />
                        <Fieldset legend="Endereço">
                            <p><strong>Rua/Av:</strong> {this.state.dados['Endereco']}</p>
                            <p><strong>CEP:</strong> {this.state.dados['CEP']}<strong>Bairro:</strong> {this.state.dados['Bairro']}</p>
                            <p><strong>Cidade:</strong>  {this.state.dados['Nome_cidade']}</p>
                        </Fieldset>
                        <br />
                        <Fieldset legend="Documentos">
                            <p><strong>RG:</strong> {this.state.dados['RG']} <strong>CPF:</strong>  {this.state.dados['CPF']}</p>
                            <p><strong>CNH:</strong>  {this.state.dados['CNH']}<strong></strong> </p>
                            <p><strong>Carteira de trabalho:</strong>  {this.state.dados['CarteiraTrabalho']}</p>

                        </Fieldset>
                        <br />
                        <Fieldset legend="Dados bancários">
                            <p><strong>Banco:</strong> {this.state.dados['Banco']} </p>
                            <p><strong>Agencia:</strong>  {this.state.dados['Agencia']} <strong>Conta:</strong>  {this.state.dados['Conta']} </p>

                        </Fieldset>
                        <br />
                        <Button label="Editar dados" onClick={() => { this.props.history.push('/editar-perfil'); }} />
                    </div>
                </Card>
            </div>
        );
    }
}

export default MeusDados;
